var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ethers } from 'ethers';
import { UniswapV3 as UniswapV3Helper } from '../Fct/plugins/uniswapV3/helpers/UniswapV3';
import { Sushiswap as SushiswapHelper } from './plugins/sushiswap/helpers/Sushiswap';
import { Uniswap as UniswapHelper } from './plugins/uniswap/helpers/Uniswap';
export var getTokenDecimals = function (_a) {
    var address = _a.address, provider = _a.provider;
    return __awaiter(void 0, void 0, void 0, function () {
        var decimals, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, new ethers.Contract(address, ['function decimals() view returns (uint8 decimals)'], provider).decimals()];
                case 1:
                    decimals = _b.sent();
                    return [2 /*return*/, decimals];
                case 2:
                    e_1 = _b.sent();
                    console.error(e_1);
                    return [2 /*return*/, 18];
                case 3: return [2 /*return*/];
            }
        });
    });
};
export var getSwapPath = function (_a) {
    var chainId = _a.chainId, tokenIn = _a.tokenIn, tokenOut = _a.tokenOut, protocol = _a.protocol, helper = _a.helper, service = _a.service;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, sushiswapHelper, tokenInDecimals, tokenOutDecimals, amountIn, suhsiRes, suhsiPath, uniswapHelper, tokenInDecimalsUniV2, tokenOutDecimalsUniV2, amountInUniV2, res, resPath, inchHelper, tokenInDecimalsInch, tokenOutDecimalsInch, amountInInch, inchRes, inchPath, uniswapV3Helper, tokenInDecimalsUniV3, tokenOutDecimalsUniV3, amountInUniV3, uniswapV3Res, methodParams, path, uniswapV3ResPath;
        var _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _b = protocol;
                    switch (_b) {
                        case 'SUSHISWAP': return [3 /*break*/, 1];
                        case 'UNISWAP_V2': return [3 /*break*/, 5];
                        case '1INCH': return [3 /*break*/, 9];
                        case 'UNISWAP_V3': return [3 /*break*/, 13];
                    }
                    return [3 /*break*/, 19];
                case 1:
                    sushiswapHelper = helper ||
                        new SushiswapHelper({
                            chainId: chainId,
                        });
                    return [4 /*yield*/, getTokenDecimals({ address: tokenIn.address, provider: sushiswapHelper.library })];
                case 2:
                    tokenInDecimals = _h.sent();
                    return [4 /*yield*/, getTokenDecimals({ address: tokenOut.address, provider: sushiswapHelper.library })];
                case 3:
                    tokenOutDecimals = _h.sent();
                    amountIn = tokenIn.amount || '1' + '0'.repeat(tokenInDecimals);
                    return [4 /*yield*/, sushiswapHelper.getSwapParams({
                            input: {
                                currency: {
                                    address: tokenIn.address,
                                    decimals: tokenInDecimals,
                                },
                                amount: amountIn,
                            },
                            output: {
                                currency: {
                                    address: tokenOut.address,
                                    decimals: tokenOutDecimals,
                                },
                                amount: tokenOut.amount,
                            },
                        })];
                case 4:
                    suhsiRes = _h.sent();
                    suhsiPath = (_d = (_c = suhsiRes === null || suhsiRes === void 0 ? void 0 : suhsiRes.params) === null || _c === void 0 ? void 0 : _c.methodParams) === null || _d === void 0 ? void 0 : _d.path;
                    if (!suhsiRes || (suhsiRes && suhsiRes.state === 'INVALID') || !suhsiPath) {
                        console.error('Invalid Trade');
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, { path: suhsiPath, amountIn: suhsiRes.inputAmount, amountOut: suhsiRes.outputAmount }];
                case 5:
                    uniswapHelper = helper ||
                        new UniswapHelper({
                            chainId: chainId,
                        });
                    return [4 /*yield*/, getTokenDecimals({ address: tokenIn.address, provider: uniswapHelper.library })];
                case 6:
                    tokenInDecimalsUniV2 = _h.sent();
                    return [4 /*yield*/, getTokenDecimals({
                            address: tokenOut.address,
                            provider: uniswapHelper.library,
                        })];
                case 7:
                    tokenOutDecimalsUniV2 = _h.sent();
                    amountInUniV2 = tokenIn.amount || tokenOut.amount ? tokenIn.amount : '1' + '0'.repeat(tokenInDecimalsUniV2);
                    return [4 /*yield*/, uniswapHelper.getSwapParams({
                            input: {
                                currency: {
                                    address: tokenIn.address,
                                    decimals: tokenInDecimalsUniV2,
                                },
                                amount: amountInUniV2,
                            },
                            output: {
                                currency: {
                                    address: tokenOut.address,
                                    decimals: tokenOutDecimalsUniV2,
                                },
                                amount: tokenOut.amount,
                            },
                        })];
                case 8:
                    res = _h.sent();
                    resPath = (_f = (_e = res === null || res === void 0 ? void 0 : res.params) === null || _e === void 0 ? void 0 : _e.methodParams) === null || _f === void 0 ? void 0 : _f.path;
                    if (!res || (res && res.state === 'INVALID') || !resPath) {
                        console.error('Invalid Trade');
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, { path: resPath, amountIn: res.inputAmount, amountOut: res.outputAmount }];
                case 9:
                    inchHelper = helper;
                    if (!inchHelper) {
                        console.error('Invalid Helper');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getTokenDecimals({ address: tokenIn.address, provider: inchHelper.library })];
                case 10:
                    tokenInDecimalsInch = _h.sent();
                    return [4 /*yield*/, getTokenDecimals({ address: tokenOut.address, provider: inchHelper.library })];
                case 11:
                    tokenOutDecimalsInch = _h.sent();
                    amountInInch = tokenIn.amount ? tokenIn.amount : '1' + '0'.repeat(tokenInDecimalsInch);
                    return [4 /*yield*/, inchHelper.getSwapParams({
                            input: {
                                currency: {
                                    address: tokenIn.address,
                                },
                                amount: amountInInch,
                            },
                            output: {
                                currency: {
                                    address: tokenOut.address,
                                },
                            },
                            service: service,
                        })];
                case 12:
                    inchRes = _h.sent();
                    if (!inchRes || (inchRes && inchRes.state === 'INVALID')) {
                        console.error('Invalid Trade');
                        return [2 /*return*/];
                    }
                    inchPath = inchRes.params.methodParams.pools;
                    return [2 /*return*/, {
                            path: inchPath,
                            amountIn: inchRes.inputAmount,
                            amountOut: inchRes.outputAmount,
                            value: inchRes.params.value,
                        }];
                case 13:
                    uniswapV3Helper = helper ||
                        new UniswapV3Helper({
                            chainId: chainId,
                        });
                    return [4 /*yield*/, getTokenDecimals({
                            address: tokenIn.address,
                            provider: uniswapV3Helper.library,
                        })];
                case 14:
                    tokenInDecimalsUniV3 = _h.sent();
                    return [4 /*yield*/, getTokenDecimals({
                            address: tokenOut.address,
                            provider: uniswapV3Helper.library,
                        })];
                case 15:
                    tokenOutDecimalsUniV3 = _h.sent();
                    amountInUniV3 = tokenIn.amount || tokenOut.amount ? tokenIn.amount : '1' + '0'.repeat(tokenInDecimalsUniV3);
                    return [4 /*yield*/, uniswapV3Helper.getSwapParams({
                            input: {
                                currency: {
                                    address: tokenIn.address,
                                    decimals: tokenInDecimalsUniV3,
                                },
                                amount: amountInUniV3,
                            },
                            output: {
                                currency: {
                                    address: tokenOut.address,
                                    decimals: tokenOutDecimalsUniV3,
                                },
                                amount: tokenOut.amount,
                            },
                        })];
                case 16:
                    uniswapV3Res = _h.sent();
                    if (!uniswapV3Res || (uniswapV3Res && uniswapV3Res.state === 'INVALID')) {
                        console.error('Invalid Trade');
                        return [2 /*return*/];
                    }
                    methodParams = (_g = uniswapV3Res === null || uniswapV3Res === void 0 ? void 0 : uniswapV3Res.params) === null || _g === void 0 ? void 0 : _g.methodParams;
                    if (!((methodParams === null || methodParams === void 0 ? void 0 : methodParams.params_tuple) && 'fee' in (methodParams === null || methodParams === void 0 ? void 0 : methodParams.params_tuple))) return [3 /*break*/, 18];
                    return [4 /*yield*/, uniswapV3Helper.isPairExist({
                            token0: methodParams.params_tuple.tokenIn,
                            token1: methodParams === null || methodParams === void 0 ? void 0 : methodParams.params_tuple.tokenOut,
                        })];
                case 17:
                    path = _h.sent();
                    if (!path) {
                        console.error('Invalid Trade');
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, {
                            path: path.path,
                            amountIn: uniswapV3Res.inputAmount,
                            amountOut: uniswapV3Res.outputAmount,
                            fee: methodParams === null || methodParams === void 0 ? void 0 : methodParams.params_tuple.fee,
                        }];
                case 18:
                    uniswapV3ResPath = (methodParams === null || methodParams === void 0 ? void 0 : methodParams.params_tuple) && 'path' in (methodParams === null || methodParams === void 0 ? void 0 : methodParams.params_tuple) ? methodParams.params_tuple.path : undefined;
                    return [2 /*return*/, { path: uniswapV3ResPath, amountIn: uniswapV3Res.inputAmount, amountOut: uniswapV3Res.outputAmount }];
                case 19: return [2 /*return*/];
            }
        });
    });
};
